import { Component, OnInit } from '@angular/core';
import { ProductCodeQuery } from '@fgb/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';
import { ProductCode } from 'src/app/shared/utilities/product-code';

@Component({
  selector: 'fgb-challenges-page',
  templateUrl: './challenges-page.component.html',
  styleUrls: ['./challenges-page.component.scss'],
})
export class ChallengesPageComponent implements OnInit {
  screenType = ScreenType;
  productCode = ProductCode;
  sgb: boolean;

  constructor(private productCodeQuery: ProductCodeQuery) {}

  ngOnInit() {
    this.sgb = this.productCodeQuery.currentUserIsProductCode(ProductCode.SGB);
  }
}
